import './styles.css';

import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { format } from 'date-fns';
import React, { useEffect, useState } from 'react';

import { client } from './../../contentful/contentful';

const AboutUs = () => {

    const [page,setPage] = useState([]);

    useEffect( ()=>{
        client.getEntries({
            'content_type': 'page'
        }).then( response =>{
            let item = response.items.filter( item => item.fields.title === "Sobre Nosotros");
            console.log(item);
            setPage(item[0]);
        });
    }, []);

    return ( 
        <>
        <section className="ptb-100">
            <div className="container">
                <div className="row align-content-center">
                    {
                        page && page.fields !== undefined ?
                        <>
                            <div className="col-md-12 col-sm-12 col-lg-5">
                                <div>
                                    <img src={page.fields.image.fields.file.url} className="img-fluid rounded shadow-sm" alt="page-image"/>
                                </div>
                            </div>
                            <div className="col-md-12 col-sm-12 col-lg-6">
                                <div className="mb-4">
                                    <h4 class="mb-1">{page.fields.title}</h4>
                                    <span>{format(new Date(page.fields.createdDate),"MMM dd yyyy")}</span>
                                </div>
                                <div class="text-content mt-20">
                                    <p>
                                        {documentToReactComponents(page.fields.longDescription)}
                                    </p>
                                </div>
                            </div> 
                        </>    
                        : null
                    }
                </div>
            </div>
        </section>
        {/* <section id="download" class="video-promo ptb-100 background-img templateClasses">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-md-6">
                            <div class="video-promo-content mt-4 text-center">
                                <a href="https://www.youtube.com/watch?v=9No-FiEInLA" class="popup-youtube video-play-icon d-inline-block">
                                <span class="ti-control-play"></span> 
                                </a><h5 class="mt-4 text-white">Watch video overview</h5>
                            </div>
                        </div>
                    </div>
                </div>
        </section> */}
        </>
        // <div className="module ptb-100">
        //     <div className="container">
        //         <div className="row ptb-100">
        //             <p>hola</p>
        //         </div>
        //     </div>
        // </div>
    );
}
 
export default AboutUs;